import React, { ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// import styles from './ea-select.module.scss';


const EaSelect = (props: any): ReactElement => {
  const { t } = useTranslation();

  // WCAG 3.3.1 / 4.1.2: error asociado al control mediante aria-describedby.
  const fieldError = props.error?.[props.name]?.isValid === false
    ? props.error[props.name].message
    : (props.error && props.error.isValid === false ? props.error.message : undefined);
  const hasError = Boolean(fieldError);
  const errorId = props.idInput ? `${props.idInput}-error` : undefined;

  return (
    <>
      <label htmlFor={props.idInput}>{props.label}</label>
      <select
        id={props.idInput}
        name={props.name}
        {...props.bindingField}
        data-qa={props.inputDataQa}
        value={props.value} 
        disabled={props.disabled!=undefined?props.disabled:false}
        aria-invalid={hasError || undefined}
        aria-describedby={hasError ? errorId : undefined}
      >
        {props.listItems && props.listItems.map((item:any, index:number) => (
          <option
            key={`${item.value}-${index}`}
            value={item.value}
          >
            {t(item.name)}
          </option>
        ))}
      </select>

      {hasError && <span className="error" id={errorId}>{ t(fieldError) }</span>}
    </>
  );
};

export default EaSelect;
